import React from 'react';

export function Languages() {
  return (
    <div className="bannerLanguages">
      <h1>Languages</h1>
    </div>
  );
}
